import type {SidebarLink, UserShortcut} from '../types'
import {supportedIconColors, supportedIconNames} from '../types'

export function isValidShortcutName(shortcut: UserShortcut): boolean {
  return !!shortcut.name && shortcut.name.trim().length > 0
}

export function isValidShortcutQuery(shortcut: UserShortcut): boolean {
  return !!shortcut.query && shortcut.query.trim().length > 0
}

function isValidShortcutIcon(shortcut: UserShortcut): boolean {
  return supportedIconNames.includes(shortcut.icon)
}

function isValidShortcutColor(shortcut: UserShortcut): boolean {
  return supportedIconColors.includes(shortcut.color)
}

export function isValidShortcut(shortcut: UserShortcut): boolean {
  return (
    isValidShortcutName(shortcut) &&
    isValidShortcutQuery(shortcut) &&
    isValidShortcutIcon(shortcut) &&
    isValidShortcutColor(shortcut)
  )
}

export function getShortcutsWithSaved(existingShortcuts: SidebarLink[], savedShortcut: SidebarLink) {
  const exists = existingShortcuts.some(shortcut => shortcut.id === savedShortcut.id)

  if (exists) {
    return existingShortcuts.map(shortcut => (shortcut.id === savedShortcut.id ? savedShortcut : shortcut))
  } else {
    return [...existingShortcuts, savedShortcut]
  }
}
